module.exports = __webpack_public_path__ + "static/media/filled-horizontal.ced99042.svg";